import React from "react";

export default function Section6() {
  return (
    <div className="my-10 md:px-16">
      {/* card 1 */}
      <div className="shadow-[1px_1px_10px_0px] shadow-slate-200 m-8 p-4 md:p-8 ">
        <div className="bg-white space-y-8 mt-10 ">
          <img
            alt="/"
            src="https://assets-global.website-files.com/5e4482baa13a1926b23e2187/6079edaef8efe087dde4d7fd_quotation.svg"
          ></img>
          <img
            alt="/"
            src="https://assets-global.website-files.com/5e4482baa13a1926b23e2187/61016f0960ab7abb8864a98e_stars.svg"
          />
          <div>
            <p className=" text-left">
              Another day and another box of fruit bought off the Flashfood app!
              I love using this app and keeping perfectly good food from going
              into the landfill. All of the food posted on the app is reaching
              its best before date but still perfectly good to eat. And it was
              only $5.00! 😊
            </p>
          </div>
          <div className=" text-left">@aceliacstravels from Airdrie, Alberta</div>
        </div>
      </div>
      {/* card 2 */}
      <div className="shadow-[1px_1px_10px_0px] shadow-slate-200 m-8 p-4 md:p-10 ">
          <div className="bg-white space-y-8 mt-10 ">
            <img
                alt="/"
                src="https://assets-global.website-files.com/5e4482baa13a1926b23e2187/6079edaef8efe087dde4d7fd_quotation.svg"
            ></img>
            <img
                alt="/"
                src="https://assets-global.website-files.com/5e4482baa13a1926b23e2187/61016f0960ab7abb8864a98e_stars.svg"
            />
            <div>
                <p className=" text-left">
                I despise wasting food, and I love getting a great deal. flashfood
                makes it so simple for me to actually save food destined for the
                dump, and all they ask is that I pay a fraction of the price for
                it. In my personal opinion, the food is fine! No issues
                whatsoever! In what world does this service not make perfect
                sense?
                </p>
                </div>
              <div className=" text-left">@Peter T. from Toronto</div>
            
          </div>
      </div>
      {/* card 3 */}
      <div className="shadow-[1px_1px_10px_0px] shadow-slate-200 m-8 p-4 md:p-10  ">
            <div className="bg-white space-y-8 mt-10 ">
            <img
                alt="/"
                src="https://assets-global.website-files.com/5e4482baa13a1926b23e2187/6079edaef8efe087dde4d7fd_quotation.svg"
            ></img>
            <img
                alt="/"
                src="https://assets-global.website-files.com/5e4482baa13a1926b23e2187/61016f0960ab7abb8864a98e_stars.svg"
            />
            <div>
                <p className=" text-left">
                Wow! I am absolutely delighted with my first box! A great selection of produce (carrots, English cucumber, peppers, mushrooms, onions, apples, oranges and the protein (kielbasa, chicken meatballs, teriyaki chicken meatballs, pulled chicken) was awesome as well! Will most certainly order again!
                </p>
                </div>    
                <div className=" text-left">Pauline P. from Wyandotte, Michigan</div>
            
            </div>
      </div>


    {/* card4 */}
    <div className="shadow-[1px_1px_10px_0px] shadow-slate-200 m-8 p-4 md:p-10 ">
        <div className="bg-white space-y-8 mt-10 ">
          <img
            alt="/"
            src="https://assets-global.website-files.com/5e4482baa13a1926b23e2187/6079edaef8efe087dde4d7fd_quotation.svg"
          ></img>
          <img
            alt="/"
            src="https://assets-global.website-files.com/5e4482baa13a1926b23e2187/61016f0960ab7abb8864a98e_stars.svg"
          />
          <div>
            <p className=" text-left">
            Love it. between the wife and I who have the app on both our phones, we saved over $1200. instead of stores throwing out expired food to the dump, they can get rid of food when it's close to expiration dates. love it. I highly recommend it.
            </p>
          </div>
          <div className=" text-left">Brett C. from Ajax </div>
        </div>
      </div>


    </div>
  );
}
